import { createAsyncThunk } from "@reduxjs/toolkit";

import { type CheckoutSettings } from "@fitness-app/data-models/entities/ProductsSettings";
import { getErrorMessage } from "@fitness-app/utils";

import { getLoggedUser } from "../../../helpers/getLoggedUser";
import { getTeamOwnerId } from "../../../helpers/getTeamOwnerId";
import { type ActionParams, type AsyncThunkCreator } from "../../../index";
import { PRODUCTS_SETTINGS_REDUCER_NAME } from "../types";

export const updateCheckoutSettings = createAsyncThunk<
  void,
  ActionParams<{ checkoutSettings: CheckoutSettings; contactEmail: string }>,
  AsyncThunkCreator<string>
>(
  `${PRODUCTS_SETTINGS_REDUCER_NAME}/updateCheckoutSettings`,
  async ({ onSuccess, onFailure, payload }, { rejectWithValue, extra: { db, auth } }) => {
    try {
      const currentUser = await getLoggedUser(auth);

      const { error } = await db
        .from("products_settings")
        .update({ checkoutSettings: payload.checkoutSettings, contactEmail: payload.contactEmail })
        // `userId` to id tenanta, tak samo jak w fetchProductsSettings — bez
        // tego zapis członka zespołu trafiał w nieistniejący wiersz i ginął.
        .eq("userId", getTeamOwnerId(currentUser));

      if (error) {
        throw new Error(error.message);
      }

      onSuccess?.();
    } catch (e) {
      onFailure?.();

      return rejectWithValue(getErrorMessage(e));
    }
  },
);
